/* unplugin-vue-components disabled */import { render } from "./UserRegistrationPurple.vue?vue&type=template&id=2c6b2616&scoped=true"
import script from "./UserRegistrationPurple.vue?vue&type=script&lang=js"
export * from "./UserRegistrationPurple.vue?vue&type=script&lang=js"

import "./UserRegistrationPurple.vue?vue&type=style&index=0&id=2c6b2616&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6b2616"]])

export default __exports__